<div class="db-workspace">
    <div class="db-workspace__content">
        <ds-tabs class="db-workspace__tabs" [activeTabId]="workspaceTab" (onActiveTabChange)="accountsTabChange($event)"
                 [ngClass]="{'db-workspace__tabs-with-offer': (currentSubscription && currentSubscription?.type === UserSubscriptionType.FREE && websiteCopied) || (currentSubscription?.subscriptionId === UserSubscriptionIds.FREE_BASE) || (currentSubscription && [UserSubscriptionType.ONE_PRODUCT, UserSubscriptionType.PREMIUM].includes(currentSubscription?.type) && aiStarterAnnual && aiStarterAnnual.plan.trialPeriodNumber)}">
            <ds-tab-head [blackStyle]="true" tabId="workspace-settings" [activeTabId]="workspaceTab">
                <span class="db-workspace__sidebar-link">{{ 'text_workspaceInfo' | dbText }}</span>
            </ds-tab-head>
            <ds-tab-head [blackStyle]="true" tabId="subscription-plan" [activeTabId]="workspaceTab">
                <span class="db-workspace__sidebar-link">{{ 'text_subscriptionPlan' | dbText }}</span>
            </ds-tab-head>
            @if (currentSubscription && !currentSubscription?.is_non_billable) {
                <ds-tab-head [blackStyle]="true" tabId="billing-details" [activeTabId]="workspaceTab"
                             [hideTab]=" currentSubscription?.trialClient">
                    <span class="db-workspace__sidebar-link">{{ 'text_billingDetails' | dbText }}</span>
                </ds-tab-head>
            }
            @if (currentSubscription && !currentSubscription?.is_non_billable) {
                <ds-tab-head [blackStyle]="true" tabId="payment-methods" [activeTabId]="workspaceTab"
                             [hideTab]="currentSubscription?.subscriptionId === Config.defaultStarterPlanId || currentSubscription?.trialClient || currentSubscription?.freeBaseClient || currentSubscription?.trialBoosterClient || currentSubscription?.trialOptimizerClient">
                    <span class="db-workspace__sidebar-link">{{ 'text_managePaymentTitlePaypal' | dbText }}</span>
                </ds-tab-head>
            }
            @if (currentSubscription && !currentSubscription?.is_non_billable && !isMobile) {
                <ds-tab-head [blackStyle]="true" [activeTabId]="workspaceTab" tabId="invoices"
                             [hideTab]="currentSubscription?.trialClient">
                    <span class="db-workspace__sidebar-link">{{ 'text_invoices' | dbText }}</span>
                </ds-tab-head>
            }
            @switch (workspaceTab) {
                @case ('workspace-settings') {
                    <ds-tab-content>
                        <div class="db-panel_flex db-panel-billing-info">
                            <div class="db-panel__body" (scroll)="onMobileScroll()">
                                <db-workspace-settings></db-workspace-settings>
                            </div>
                        </div>
                    </ds-tab-content>
                }
                @case ('subscription-plan') {
                    <ds-tab-content>
                        <div class="db-panel_flex db-panel-billing-info"
                             [ngClass]="{'db-panel-subscription-tab': (workspaceTab === 'subscription-plan' && currentSubscription?.type !== 'starter')}">
                            <div class="db-panel__body" (scroll)="onMobileScroll()">
                                <db-subscription-plan [userSubscription]="currentSubscription"
                                                      [annualPrice]="annualPrice"></db-subscription-plan>
                            </div>
                        </div>
                    </ds-tab-content>
                }
                @case ('billing-details') {
                    <ds-tab-content>
                        <div class="db-panel_flex db-panel-billing-info">
                            <div class="db-panel__body" (scroll)="onMobileScroll()">
                                <db-billing-details></db-billing-details>
                            </div>
                        </div>
                    </ds-tab-content>
                }
                @case ('payment-methods') {
                    <ds-tab-content>
                        <div class="db-panel_flex db-panel-billing-info">
                            <div class="db-panel__body" (scroll)="onMobileScroll()">
                                <db-billing></db-billing>
                            </div>
                        </div>
                    </ds-tab-content>
                }
                @case ('invoices') {
                    <ds-tab-content>
                        <div class="db-panel_flex db-panel-billing-info">
                            <div id="db-panel__body" class="db-panel__body" (scroll)="onMobileScroll()">
                                <db-payment-history></db-payment-history>
                            </div>
                        </div>
                    </ds-tab-content>
                }
            }
        </ds-tabs>
    </div>
</div>
